// @flow

import _ from "lodash";

import { IDependencyResolver } from "../annotation/di";
import { ModuleContainer } from "./module-container";

import type { Module } from "../annotation/module";
import type { IController } from "app/rgs/interfaces";
import type { TAdditionalParams } from "../annotation/di";

export class DependencyResolver implements IDependencyResolver {
	_moduleContainer: ModuleContainer;

	constructor(moduleContainer: ModuleContainer) {
		this._moduleContainer = moduleContainer;
	}

	get = (moduleName: string): any => {
		const result = this._moduleContainer.getModuleByName(moduleName);
		return result;
	};

	/*
	 * Instead it you have to use .create()
	 *
	 */
	createController(
		connector: Module | Controller,
		additionalParams?: TAdditionalParams,
	): * {
		const {
			controller: Controller,
			dependencies,
			incomingArgs,
		} = connector || {};

		//to provide only first argument without additional args
		if (!Controller && _.isEmpty(additionalParams)) {
			const Constructor = connector;
			return new Constructor(this._moduleContainer.resolver);
		}

		// Resolve dependencies
		const dependentModules = (dependencies || []).map(
			this.getServiceByName,
		);

		// Instantiate the module
		return new Controller(
			this._moduleContainer.resolver,
			additionalParams || incomingArgs,
			...dependentModules,
		);
	}

	/*
	 * Instantiates the module
	 * and performs constructor injection.
	 */
	create(Controller: Class<IController>) {
		return this.createController(Controller);
	}

	getViewModelByName = (name: string, argument: *) => {
		const viewModule = this.get(name);
		const params = _.get(argument, "context.params");

		return this.createController(viewModule, params);
	};

	getServiceByName = (serviceName: string): * => {
		return this._moduleContainer.getModuleByName(serviceName);
	};
}
